import React, { useState, useEffect, useCallback } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import * as Yup from "yup";
import { handleGetRequest } from "../../service/GetTemplate";
import { handlePostRequest } from "../../service/PostTemplate";
import { handlePatchRequest } from "../../service/PatchTemplete";
import { useDispatch } from "react-redux";
import { ProgressSpinner } from "primereact/progressspinner";
import { useHistory, useLocation } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import OrderDispatch from "./OrderDispatch";
import { SelectButton } from "primereact/selectbutton";
import debounce from 'lodash/debounce';
import { confirmDialog } from "primereact/confirmdialog";

const AddEditOrderManagement = () => {
    const [isDelivered, setIsDelivered] = useState()
    const [currentStatus, setCurrentStatus] = useState()
    const [totalBill, setTotalBill] = useState()
    const [disabled, setDisabled] = useState(false)
    const [processDisabled, setProcessDisabled] = useState(false)

    let { search, state } = useLocation();

    const myOrderSplitId2 = search?.split('=')[1];
    const query = new URLSearchParams(search);
    const orderRowData = query.get("orderid");

    const editable = orderRowData ? true : false;

    const [loading, setLoading] = useState(false);
    const [fileUploadData, setfileUploadData] = useState("");
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [displayDialog, setDisplayDialog] = useState(false);
    const [productData, setProductData] = useState();

    const history = useHistory();

    const dispatch = useDispatch();

    useEffect(() => {
        if (orderRowData !== undefined && orderRowData !== null && editable === true) {
            getUsersByID();
        }
    }, []);


    const onHide = (name) => {
        setDisplayDialog(false);
    };

    const handleBack = (e) => {
        e.preventDefault();
        history.push("./ordermanagement")
        onHide();
    };

    const handleDialog = () => {

        setDisplayDialog(true);

    };
    const handleCancel = async () => {
        // e.preventDefault();
        const res = await handleGetRequest(`api/v1/order/orderCancel?orderId=${orderRowData}`, true)
        history.push("./ordermanagement")
        onHide();
    };

    const [status, setStatus] = useState();
    const [id, setId] = useState();
    const [trackingId, setTrackingId] = useState();
    const [objectData, setObjectData] = useState([]);
    const [checked, setChecked] = useState(objectData?.payment);

    const getUsersByID = async () => {
        const data = {};
        data["roleId"] = orderRowData;
        setLoading(true);
        const res = await handleGetRequest(`api/v1/order/detail?orderId=${orderRowData}`, false);
        // console.log("res", res.shippingAddress.firstName);
        setIsDelivered(res?.isDeliver)
        setCurrentStatus(res?.status)
        if (res) {
            setObjectData(res)
            setTotalBill(res?.totalBill)
            setStatus(res.status);
            setId(res._id);
            setTrackingId(res.trackingId);
            setProductData(res?.product)
            const keyData = res;
            setLoading(false);
            Object.keys(keyData).forEach((key) => {
                if (formik.initialValues.hasOwnProperty(key)) {
                    formik.setFieldValue(key, keyData[key]);
                }
            });
            // for first name and last name
            // const customerName = keyData?.customer?.firstName + " " + keyData?.customer?.lastName;
            const customerName = keyData?.shippingAddress?.firstName;
            const customerEmail = keyData?.shippingAddress?.email;
            formik.setFieldValue("customerName", customerName)
            formik.setFieldValue("customerEmail", customerEmail)
            formik.setFieldValue("address", keyData?.shippingAddress?.addressLine)
            formik.setFieldValue("contact", keyData?.shippingAddress?.contact)

            const province = keyData?.shippingAddress?.province;
            formik.setFieldValue("province", province)

            const zipCode = keyData?.shippingAddress?.zipCode;
            formik.setFieldValue("zipCode", zipCode)

            const region = keyData?.shippingAddress?.Shippingregion?.taxType;
            formik.setFieldValue("region", region)

        }
        setLoading(false);
    };


    useEffect(() => {
        setChecked(objectData?.payment)
    }, [objectData?.payment])

    const paymentStatus = objectData?.payment ? 'Paid' : 'Unpaid';
    const paymentMode = objectData?.paymentMode === 'cod' ? 'COD' :
        objectData?.paymentMode === 'E-Transfer' ? 'Interac e Transfer' :
            'Stripe';

    const getOrderData = () => {
        history.push("./ordermanagement")
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("This field is required."),
        description: Yup.string().required("This field is required.").nullable(),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            customerName: "",
            customerEmail: "",
            address: "",
            contact: "",
            province: "",
            zipCode: "",
            region: "",

            // permissionsId: "",
        },


        onSubmit: async (data) => {
            setLoading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            if (editable === true) {
                data["categoryId"] = orderRowData;
                const res = await dispatch(handlePatchRequest(data, "api/v1/category/", true, true));
                if (res?.status === 200) {
                    await getOrderData();
                    formik.resetForm();
                    onHide();
                }
            } else {
                data["icon"] = fileUploadData;
                const res = await dispatch(handlePostRequest(data, "api/v1/category/", true, true));
                if (res?.status === 200) {
                    await getOrderData();
                    formik.resetForm();
                    onHide();
                }
            }
            setLoading(false);
            setloadingIcon("pi pi-save");
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const categoryTemplete = (rowData) => {
        return <React.Fragment>{rowData?.productId?.category?.name}</React.Fragment>;
    };
    const subCategoryTemplete = (rowData) => {

        return <React.Fragment>{rowData?.productId?.subcategory?.name}</React.Fragment>;
    };
    const productTemplete = (rowData) => {
        return <React.Fragment>{rowData?.productId?.name}</React.Fragment>;
    };

    const sizeTemplete = (rowData) => {
        return <React.Fragment>{rowData?.size ? rowData?.size : "N/A"}</React.Fragment>;
    };

    // const handleToggle = () => {
    //     setPaymentStatus(paymentStatus === 'unpaid' ? 'paid' : 'unpaid');
    // };
    const statusOption = [
        { label: 'Paid', value: true },
        { label: 'Unpaid', value: false },
    ];

    const deleteSubCategoryPopup = (e, objectData) => {
        confirmDialog({
            message: "Are you sure you want to change the payment status?",
            header: "Status Change Confirmation",
            // icon: "pi pi-trash",
            acceptClassName: "Savebtn",
            rejectClassName: "Cancelbtn",
            accept: () => {
                handleStatusChange(e, objectData);
            },
            reject: () => { },
        });
    };

    const handleStatusChange = useCallback(
        debounce(async (e, objectData) => {
            e.preventDefault();
            const obj = {
                orderId: objectData?.orderId,
                paymentMode: objectData.paymentMode,
                payment: e.value
            };
            try {
                const res = await dispatch(handlePatchRequest(obj, "api/v1/order/", true, true));
                if (res?.status === 200) {
                    await getUsersByID();
                    setChecked(e.value);
                } else {
                    console.error('Failed to update payment status');
                }
            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 1000), // Debounce delay of 1000ms
        [dispatch, getUsersByID]
    );


    useEffect(() => {
        if (isDelivered === false) {
            setDisabled(true)
        }
    }, [isDelivered])

    useEffect(() => {
    // 1️⃣ Block if returned
    if (currentStatus === 'Returned' || currentStatus === 'Return') {
        setProcessDisabled(true);
        console.log('case 1 - returned');
        return;
    }

    // 2️⃣ Allow COD orders to be processed even if unpaid
    if (
        objectData?.paymentMode === 'cod' &&
        currentStatus === 'Pending' &&
        isDelivered === false
    ) {
        setProcessDisabled(false);
        console.log('case 2 - COD can process');
        return;
    }

    // 3️⃣ Regular unpaid non-COD orders (e.g. E-Transfer) should be blocked
    if (
        checked === false &&
        paymentStatus === 'Unpaid' &&
        currentStatus === 'Pending' &&
        isDelivered === false
    ) {
        setProcessDisabled(true);
        console.log('case 3 - unpaid non-COD');
        return;
    }

    // 4️⃣ Paid and pending → allow processing
    if (
        checked === true &&
        paymentStatus === 'Paid' &&
        currentStatus === 'Pending' &&
        isDelivered === false
    ) {
        setProcessDisabled(false);
        console.log('case 4 - paid and pending');
        return;
    }

    // 5️⃣ Delivered orders → disable
    if (
        checked === true &&
        paymentStatus === 'Paid' &&
        currentStatus === 'Delivered' &&
        isDelivered === true
    ) {
        setProcessDisabled(true);
        console.log('case 5 - delivered');
        return;
    }

    setProcessDisabled(false); // default
}, [currentStatus, checked, isDelivered, paymentStatus, objectData?.paymentMode]);

    // useEffect(() => {
    //     if (currentStatus == 'Returned' || currentStatus == 'Return') {
    //         setProcessDisabled(true)
    //         console.log('case 1')
    //         return
    //     }
    //     else if (checked === false && paymentStatus == 'Unpaid' && currentStatus == 'Pending' && isDelivered === false) {
    //         setProcessDisabled(true)
    //         console.log('case 2')
    //         return
    //     }
    //     else if (checked === true && paymentStatus == 'Paid' && currentStatus == 'Pending' && isDelivered === false) {
    //         setProcessDisabled(false)
    //         console.log('case 3')
    //         return
    //     }
    //     else if (checked === true && paymentStatus == 'Paid' && currentStatus == 'Delivered' && isDelivered === true) {
    //         setProcessDisabled(true)
    //         console.log('case 4')
    //         return
    //     }
    //     else {
    //         return null
    //     }

    // }, [currentStatus, checked, isDelivered, paymentStatus])

    return (
        <>
            <Dialog header="Order Status" visible={displayDialog} style={{ width: "40vw" }} closable={true} onHide={() => onHide('displayDialog')}>
                <OrderDispatch myOrderSplitId2={myOrderSplitId2} status={status} id={state?.id} trackingId={trackingId} />
            </Dialog>

            {loading ? (
                <ProgressSpinner style={{ display: "flex", justifyContent: "center", alignItem: "center", height: "50vh" }} strokeWidth="2" stroke-miterlimit="10" />
            ) : (
                <form onSubmit={formik.handleSubmit}>
                    <div className="card headr_bg">
                        <div className="card-header">
                            <label>Details</label>
                        </div>
                        <div className="card-body">
                            <div className="grid">
                                <div className="col-12 md:col-12 xl:col-12 lg:col-12 pt-3 pb-3">
                                    <label>
                                        <b> Customer Details</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-4 xl:col-4 lg:col-4">
                                    <div className="flex flex-column">
                                        <label className="mb-2">Customer's Name</label>
                                        <InputText disabled={true} id="customerName" name="customerName" value={formik?.values?.customerName} type="text" placeholder="Enter" className="w-full md:w-10 inputClass" />
                                    </div>
                                </div>
                                <div className="col-12 md:col-4 xl:col-4 lg:col-4">
                                    <div className="flex flex-column">
                                        <label className="mb-2">Email Address</label>
                                        <InputText disabled={true} id="customerEmail" name="customerEmail" value={formik?.values?.customerEmail} type="text" placeholder="Enter" className="w-full md:w-10 inputClass" />
                                    </div>
                                </div>
                                <div className="col-12 md:col-4 xl:col-4 lg:col-4">
                                    <div className="flex flex-column">
                                        <label className="mb-2">Contact Number</label>
                                        <InputText disabled={true} id="contact" name="contact" value={formik?.values?.contact} type="text" placeholder="Enter" className="w-full md:w-10 inputClass" />
                                    </div>
                                </div>

                                <div className="col-12 md:col-4 xl:col-4 lg:col-4">
                                    <div className="flex flex-column">
                                        <label className="mb-2">Province</label>
                                        <InputText disabled={true} id="province" name="province" value={formik?.values?.province} type="text" placeholder="Enter" className="w-full md:w-10 inputClass" />
                                    </div>
                                </div>

                                 <div className="col-12 md:col-4 xl:col-4 lg:col-4">
                                    <div className="flex flex-column">
                                        <label className="mb-2">Delivery Address</label>
                                        <InputText disabled={true} id="address" name="address" value={formik?.values?.address} type="text" placeholder="Enter" className="w-full md:w-10 inputClass" />
                                    </div>
                                </div>

                                <div className="col-12 md:col-4 xl:col-4 lg:col-4">
                                    <div className="flex flex-column">
                                        <label className="mb-2">Zip Code</label>
                                        <InputText disabled={true} id="zipCode" name="zipCode" value={formik?.values?.zipCode} type="text" placeholder="Enter" className="w-full md:w-10 inputClass" />
                                    </div>
                                </div>

                                <div className="col-12 md:col-4 xl:col-4 lg:col-4">
                                    <div className="flex flex-column">
                                        <label className="mb-2">Region</label>
                                        <InputText disabled={true} id="region" name="region" value={formik?.values?.region} type="text" placeholder="Enter" className="w-full md:w-10 inputClass" />
                                    </div>
                                </div>

                                <div className="col-12 flex flex-row md:col-12 xl:col-12 lg:col-12 mt-3">
                                    <div className="col-9">

                                    </div>
                                    <div className="col-3 flex flex-column mr-3 ">
                                        <h4 style={{ fontWeight: "bold", fontSize: "16px" }} >Total Bill: Rs {totalBill ? totalBill?.toFixed(2) : 'N/A'}</h4>
                                        {objectData?.payment !== undefined && (
                                            <h5 style={{ fontWeight: "bold", marginTop: "-10px", fontSize: "16px" }}>
                                                Payment Status:
                                                <span style={{ color: objectData?.payment === false ? '#ff3333' : '#45bc45' }}>
                                                    {objectData?.paymentMode === 'E-Transfer' ? (
                                                        <SelectButton
                                                            disabled={objectData?.payment === true}
                                                            tooltip="Update Status"
                                                            tooltipOptions={{ position: "top" }}
                                                            value={checked} // Use checked state to set value
                                                            onChange={(e) => deleteSubCategoryPopup(e, objectData)}
                                                            options={statusOption}
                                                        />

                                                    ) : paymentStatus}
                                                </span>
                                            </h5>
                                        )}
                                        {objectData?.paymentMode && (
                                            <h5 style={{ fontWeight: "bold", marginTop: "-10px", fontSize: "16px" }}>
                                                Payment Mode: {paymentMode}
                                            </h5>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 md:col-12 xl:col-12 lg:col-12 pt-3 pb-3">
                                    <label>
                                        {/* <span className="pr-5">
                                            <b>o</b>
                                        </span> */}
                                        <b> Items Details</b>
                                    </label>
                                </div>
                                <div className="col-12 innr_padding mt-3 mb-3">
                                    <div className="grid">
                                        <div className="col-12 md:col-12 lg:col-12 xl:col-12">
                                            <div className="innr-Body ">
                                                <DataTable rows={5} responsiveLayout="scroll" value={productData}
                                                //footerColumnGroup={footerGroup}
                                                >
                                                    <Column body={categoryTemplete} header="Category" />
                                                    <Column body={subCategoryTemplete} header="Sub-Category" />
                                                    <Column body={productTemplete} header="Product Name" />
                                                    <Column field="quantity" header="Quantity" />
                                                    <Column field="sku" header="Sku" body={(rowData) => rowData?.sku.includes('/') ? rowData?.sku.split('/')[1] : rowData?.sku} />
                                                    <Column body={sizeTemplete} header="Size" />
                                                    <Column field="price" header="Price" />
                                                    <Column field="colour" body={(rowData) => rowData?.colour ? rowData?.colour : 'N/A'} header="Color" />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="grid">



                                <div className="col-12 text-center pt-4">
                                    <div className="three_btn">
                                        <Button label="Back" onClick={(e) => handleBack(e)} className="Cancelbtn p-mr-3" />
                                        <div>
                                            <Button disabled={disabled} label="Cancel" onClick={handleCancel} className="Cancelbtn p-mr-3" />
                                            <Button disabled={processDisabled} autoFocus className="Savebtn" label="Procssess" onClick={handleDialog} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}
        </>
    );
};

export default AddEditOrderManagement;